import styled from "styled-components";
import { COLORS } from "../../../../../../components/layout/theme";
import { Button } from "antd";

export const Inner = styled.div`
	display: flex;
	min-height: 200px;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;
	gap: 20px;
`;

export const CarCard = styled.div`
	display: flex;
	padding: 30px;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	background-color: ${COLORS.White};
	border-radius: 10px;
	gap: 20px;
	min-width: 300px;
`;

export const KeyCarContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${COLORS.Black};
	color: ${COLORS.White};
	border-radius: 20px;
	padding: 3px 10px;
	max-width: 80px;
`;

export const DetailCard = styled.div`
	display: flex;
	padding: 30px;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	background-color: ${COLORS.LightGrey};
	border-radius: 10px;
	min-width: 250px;
`;

export const Section = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;

export const AntdButton = styled(Button)`
	border-radius: 10px;
	padding: 20px;
`;
